import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';
import { ErrorLink } from '@apollo/client/link/error';
import { CombinedGraphQLErrors } from '@apollo/client/errors';
import { useAuthStore } from '@/store';

const API_URL = import.meta.env.VITE_API_URL || 'https://api-staging.sloxt.com/graphql';

const httpLink = new HttpLink({
  uri: API_URL,
  fetch: (uri, options) => {
    const accessToken = useAuthStore.getState().accessToken;
    const headers = new Headers(options?.headers);
    if (accessToken) {
      headers.set('authorization', `Bearer ${accessToken}`);
    }
    return fetch(uri, { ...options, headers });
  },
});

const errorLink = new ErrorLink(({ error }) => {
  const authStore = useAuthStore.getState();
  if (!authStore.isLoggedIn) return;

  if (CombinedGraphQLErrors.is(error)) {
    const hasAuthError = error.errors.some((err) => err.extensions?.code === 'UNAUTHENTICATED');
    if (hasAuthError) {
      authStore.signout();
    }
  } else {
    // Network error - only signout on HTTP 401
    if ('statusCode' in error && error.statusCode === 401) {
      authStore.signout();
    }
  }
});

export const graphqlClient = new ApolloClient({
  link: errorLink.concat(httpLink),
  cache: new InMemoryCache(),
});
